import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import AgencyPortal from "@/pages/AgencyPortal";
import Cities from "@/pages/Cities";
import Agencies from "@/pages/Agencies";
import Users from "@/pages/Users";
import Profile from "@/pages/Profile";
import Requests from "@/pages/Requests";
import Schedule from "@/pages/Schedule";
import Billing from "@/pages/Billing";
import AppShell from "@/components/layout/AppShell";

const Protected = () => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F6F8] text-[#0B1F3A]">
      <div className="font-display tracking-tight text-sm text-[#6B7280]">Carregando…</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell><Outlet /></AppShell>;
};

const RoleGate = ({ allow, children }) => {
  const { user } = useAuth();
  if (!user) return null;
  if (!allow.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

const HomeRoute = () => {
  const { user } = useAuth();
  if (["imobiliaria_admin", "imobiliaria_user"].includes(user?.role)) return <AgencyPortal />;
  return <Dashboard />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="light" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected />}>
            <Route path="/" element={<HomeRoute />} />
            <Route path="/cidades" element={<RoleGate allow={["admin_geral"]}><Cities /></RoleGate>} />
            <Route path="/imobiliarias" element={<Agencies />} />
            <Route path="/usuarios" element={<RoleGate allow={["admin_geral","administrativo","imobiliaria_admin"]}><Users /></RoleGate>} />
            <Route path="/solicitacoes" element={<Requests />} />
            <Route path="/agenda" element={<Schedule />} />
            <Route path="/faturamento" element={<RoleGate allow={["admin_geral","administrativo","financeiro","comercial","imobiliaria_admin","imobiliaria_user"]}><Billing /></RoleGate>} />
            <Route path="/perfil" element={<Profile />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
